import { useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import BugReporterPanel from './BugReporterPanel';

/**
 * Floating "report a bug" entry point, mounted app-wide (see App.tsx).
 * Replaces the `@betterbugs/web-sdk` widget (BugReportButton.tsx) — same
 * ladybug affordance, same bottom-right placement, but the submit path is
 * our own JWT-authed endpoint instead of a vendor SDK.
 */
const BugReporterButton = () => {
  const { user } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [reportId, setReportId] = useState(() => `inapp-${crypto.randomUUID()}`);

  if (!user) return null;

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => {
    setIsOpen(false);
    // Next open starts a fresh report id — a stable id is only meant to
    // dedupe retries within one in-flight report, not across reports.
    setReportId(`inapp-${crypto.randomUUID()}`);
  };

  return (
    <>
      <button
        type="button"
        onClick={handleOpen}
        title="Report a bug"
        aria-label="Report a bug"
        className="fixed z-[9998] flex items-center justify-center rounded-full transition-transform hover:scale-110"
        style={{
          bottom: 24,
          right: 24,
          width: 48,
          height: 48,
          background: '#8A5A11',
          boxShadow: '0 2px 4px rgba(138, 90, 17, 0.15)',
        }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <ellipse cx="12" cy="14" rx="6" ry="7" />
          <circle cx="12" cy="6" r="3" />
          <line x1="12" y1="7" x2="12" y2="21" />
          <circle cx="9" cy="12" r="1" fill="white" />
          <circle cx="15" cy="12" r="1" fill="white" />
          <circle cx="9" cy="16" r="1" fill="white" />
          <circle cx="15" cy="16" r="1" fill="white" />
          <line x1="10" y1="4" x2="8" y2="2" />
          <line x1="14" y1="4" x2="16" y2="2" />
        </svg>
      </button>
      <BugReporterPanel isOpen={isOpen} onClose={handleClose} reportId={reportId} />
    </>
  );
};

export default BugReporterButton;
